import React from 'react';

import AboutSDB from '../components/home/AboutSDB';
import NewsSDB from '../components/home/NewsSDB';
import MaterialsHistory from '../components/home/MaterialsHistory';

const Home = () => {
  return (
    <>
      <NewsSDB />
      <AboutSDB />
      <MaterialsHistory />
    </>
  );
};

export default Home;
